import Maintenance  from './Maintenance';

export default Maintenance


// WEBPACK FOOTER //
// ./src/app/views/frontend/maintenance/index.js